import { render, staticRenderFns } from "./ItemStepper.vue?vue&type=template&id=a4798f92&scoped=true"
import script from "./ItemStepper.vue?vue&type=script&lang=js"
export * from "./ItemStepper.vue?vue&type=script&lang=js"
import style0 from "./ItemStepper.vue?vue&type=style&index=0&id=a4798f92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4798f92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDivider,VMenu})
